import Loadable from 'react/components/loadable';

const EventQrCodePrintPreview = Loadable({
  loader: () => import('../../pages/calendar/event_qr_code_print_preview'),
});

angular.module('gym').value('EventQrCodePrintPreview', EventQrCodePrintPreview);

const EventQrCodePrintPreviewCustomizeModal = Loadable({
  loader: () => import('../../pages/calendar/event_qr_code_print_preview_customize_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('EventQrCodePrintPreviewCustomizeModal', EventQrCodePrintPreviewCustomizeModal);
